// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","629":"component---src-templates-recipe-template-tsx"}[chunkId] + "-" + {"245":"f95fc268c40713bae998","629":"0f4667f04584de58499c"}[chunkId] + ".js";
};